import React from 'react';
import JavascriptDataTypes from './JavascriptDataTypes.jsx';
import JavascriptTypeof from './JavascriptTypeof.jsx';
import JavascriptToString from './JavascriptToString.jsx';
import JavascriptTypeConversion from './JavascriptTypeConversion.jsx';

export default function JsDataTypes() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Data Types</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/data-types' className='underline'>JS Data Types</a></li>
<li><a href='/javascript/typeof' className='underline'>JS typeof</a></li>
<li><a href='/javascript/to-string' className='underline'>JS toString()</a></li>
<li><a href='/javascript/type-conversion' className='underline'>JS Type Conversion</a></li>
      </ul>
    </div>
  );
}
